import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';

const RegisterButton = ({ disabled, onClick, styles }) => (
  <div className="form-group">
    <Button
      type="submit"
      bsStyle="primary"
      disabled={disabled}
      {...(onClick ? { onClick } : {})}
      className="p-l-1 p-r-1"
      style={styles}
    >
      Register!
    </Button>
  </div>
  );

const { bool, func } = PropTypes;

RegisterButton.propTypes = {
  disabled: bool,
  onClick: func,
};

export default RegisterButton;
